import PrivacyContent from "./privacy_content";
import markdown from "@syntensor/common/_content/privacy/policy.md";

export default function PrivacyPolicy() {
  return <PrivacyContent markdown={markdown} hasDataRequest={true} />;
}
